import AreaCascader from './AreaCascader';
import BaseCascader from './BaseCascader';

/** 省市区县类型的 data_source 值集合 */
const AREA_TYPES = ['province', 'province_city', 'province_city_district'];

/**
 * CascaderForm — 级联字段分发入口
 *
 * 根据 setting.data_source 判断走哪个组件：
 *   - 省/省市/省市区县 → AreaCascader（有层级裁剪 + 必选校验）
 *   - 其他所有类型     → BaseCascader（通用，层级由数据决定）
 *
 * 对外名称保持 CascaderForm，兼容现有引用
 */
const CascaderForm = (props) => {
    const dataSource = props.setting?.data_source;
    if (AREA_TYPES.includes(dataSource)) {
        return <AreaCascader {...props} />;
    }
    return <BaseCascader {...props} />;
};

export default CascaderForm;
